import React, { useState } from "react";
import AdminSidebar from "../../components/admin/AdminSidebar";
import { Search, Bell, UserRound, Lock, CheckCircle2, AlertCircle } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { usersApi } from "../../services/api";

export default function AdminProfile() {
  const { user, refreshUser } = useAuth();
  const [form, setForm] = useState({ name: user?.name || "", phone: user?.phone || "" });
  const [pwForm, setPwForm] = useState({ currentPassword: "", newPassword: "" });
  const [saving, setSaving] = useState(false);
  const [savingPw, setSavingPw] = useState(false);
  const [profileMsg, setProfileMsg] = useState(null);
  const [pwMsg, setPwMsg] = useState(null);

  function handleChange(e) { setForm((f) => ({ ...f, [e.target.name]: e.target.value })); }
  function handlePwChange(e) { setPwForm((f) => ({ ...f, [e.target.name]: e.target.value })); }

  async function handleProfileSave(e) {
    e.preventDefault();
    setSaving(true);
    setProfileMsg(null);
    try {
      await usersApi.updateMyProfile(form);
      await refreshUser();
      setProfileMsg({ type: "success", text: "Profile updated successfully." });
    } catch (err) {
      setProfileMsg({ type: "error", text: err.response?.data?.message || "Failed to update profile." });
    } finally {
      setSaving(false);
    }
  }

  async function handlePasswordSave(e) {
    e.preventDefault();
    if (pwForm.newPassword.length < 8) {
      setPwMsg({ type: "error", text: "New password must be at least 8 characters." });
      return;
    }
    setSavingPw(true);
    setPwMsg(null);
    try {
      await usersApi.changePassword(pwForm);
      setPwForm({ currentPassword: "", newPassword: "" });
      setPwMsg({ type: "success", text: "Password changed successfully." });
    } catch (err) {
      setPwMsg({ type: "error", text: err.response?.data?.message || "Failed to change password." });
    } finally {
      setSavingPw(false);
    }
  }

  return (
    <div className="admin-shell">
      <AdminSidebar />
      <main className="admin-main">
        <header className="admin-topbar">
          <div className="admin-title">Profile</div>
          <label className="admin-search"><Search size={15} /><input placeholder="Search settings..." /></label>
          <div className="system-live"><i /> System Live</div>
          <button className="icon-button" aria-label="Notifications"><Bell size={18} /><i /></button>
        </header>
        <div className="admin-content">
          <div style={{ display: "grid", gap: 24, maxWidth: 560 }}>
            <section className="admin-panel" style={{ padding: 0 }}>
              <div className="panel-heading">
                <h2><UserRound size={18} /> Personal Info</h2>
              </div>
              <form style={{ display: "grid", gap: 20, padding: 24 }} onSubmit={handleProfileSave}>
                {profileMsg && (
                  <div className={profileMsg.type === "success" ? "auth-success" : "auth-error admin-auth-error"} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    {profileMsg.type === "success" ? <CheckCircle2 size={14} /> : <AlertCircle size={15} />} {profileMsg.text}
                  </div>
                )}
                <div className="auth-field">
                  <label htmlFor="admin-p-name">Full Name</label>
                  <input id="admin-p-name" name="name" type="text" value={form.name} onChange={handleChange} />
                </div>
                <div className="auth-field">
                  <label>Email <span className="auth-optional">(read-only)</span></label>
                  <input type="email" value={user?.email || ""} readOnly style={{ opacity: 0.5, cursor: "not-allowed" }} />
                </div>
                <div className="auth-field">
                  <label htmlFor="admin-p-phone">Phone</label>
                  <input id="admin-p-phone" name="phone" type="tel" value={form.phone} onChange={handleChange} placeholder="+1 555 000 0000" />
                </div>
                <button type="submit" className="auth-submit" style={{ maxWidth: 180 }} disabled={saving}>
                  {saving ? "Saving…" : "Save Changes"}
                </button>
              </form>
            </section>

            <section className="admin-panel" style={{ padding: 0 }}>
              <div className="panel-heading">
                <h2><Lock size={18} /> Change Password</h2>
              </div>
              <form style={{ display: "grid", gap: 20, padding: 24 }} onSubmit={handlePasswordSave}>
                {pwMsg && (
                  <div className={pwMsg.type === "success" ? "auth-success" : "auth-error admin-auth-error"} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    {pwMsg.type === "success" ? <CheckCircle2 size={14} /> : <AlertCircle size={15} />} {pwMsg.text}
                  </div>
                )}
                <div className="auth-field">
                  <label htmlFor="admin-cur-pw">Current Password</label>
                  <input id="admin-cur-pw" name="currentPassword" type="password" value={pwForm.currentPassword} onChange={handlePwChange} placeholder="••••••••" />
                </div>
                <div className="auth-field">
                  <label htmlFor="admin-new-pw">New Password</label>
                  <input id="admin-new-pw" name="newPassword" type="password" value={pwForm.newPassword} onChange={handlePwChange} placeholder="Min. 8 characters" />
                </div>
                <button type="submit" className="auth-submit" style={{ maxWidth: 200 }} disabled={savingPw}>
                  {savingPw ? "Updating…" : "Update Password"}
                </button>
              </form>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
}
